export const  hostUrl = function(){
    var port = location.port;
    var hostUrl = "http://";
     
    if(port == 80){
        hostUrl += location.hostname;
    }else{
        hostUrl += location.host;
    }
     
    return hostUrl;
}()

export function themeColor(url){
    let colors = '';
    let data = {
        mazarine:{
            header_background_color:'#135590',
            header_times_background_color:'#4A4C7D',
            header_text_color:'#fff',
            menu_background_color:'#333',
            menu_text_color:'#fff',
            copy_background_color:'#000',
            copy_text_color:'#fff',
            content_background_color:'#eee',
            content_table_color:'#FAE1CB',
            content_border_color:'#135590',
            content_text_color:'#333',
  			btn_danger_text              : '#fff',
            btn_danger_background        : '#fab6b6',
            btn_warning_text             : '#fff',
            btn_warning_background       : '#f3d19e',
            btn_info_text                : '',
            btn_info_background          : '',
            btn_success_text             : '#fff',
            btn_success_background       : '#67C23A',
            btn_primary_text             : '',
            btn_primary_background       : '',
            btn_secondary_text           : '',
            btn_secondary_background     : '',
            btn_dark_text                : '',
            btn_dark_background          : ''
        },
        orange:{
            header_background_color:'#ED6D01',
            header_times_background_color:'#4A4C7D',
            header_text_color:'#fff',
            menu_background_color:'#333',
            menu_text_color:'#fff',
            copy_background_color:'#000',
            copy_text_color:'#fff',
            content_background_color:'#eee',
            content_table_color:'#FAE1CB',
            content_border_color:'#ED6D01',
            content_text_color:'#333',
  			btn_danger_text              : '#fff',
            btn_danger_background        : '#e55353',
            btn_warning_text             : '#fff',
            btn_warning_background       : '#f9b115',
            btn_info_text                : '#fff',
            btn_info_background          : '#3399ff',
            btn_success_text             : '#fff',
            btn_success_background       : '#2eb85c',
            btn_primary_text             : '#fff',
            btn_primary_background       : '#321fdb',
            btn_secondary_text           : '#fff',
            btn_secondary_background     : '#ced2d8',
            btn_dark_text                : '#fff',
            btn_dark_background          : '#636f83'
        }

        
    }
    switch(url){
        case "http://127.0.0.1:8081":
          colors = 'mazarine' ;
          break;
        default :
          colors = 'orange' ;
          break;
    }
    return data[colors];
}

export function formateDate(date) {
    var date = new Date(date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var mi = date.getMinutes();
    m = m > 9 ? m : '0' + m;
    return y + '-' + m + '-' + d ;
}

export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

export function mGetDate(year, month){
    var d = new Date(year, month, 0);
    return d.getDate();
}

export function sortCompare(data,type){
    let arr = data ;
    arr.sort((a, b) => a[type].charCodeAt(0) - b[type].charCodeAt(0));
    return arr
}



// WEBPACK FOOTER //
// ./src/utils/fun.js